import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {IAuthProfile} from "./types/IAuthProfile";
import {fetchAuthRegister} from "./services/fetchAuthRegister/fetchAuthRegister";
import {fetchAuthLogout} from "./services/fetchAuthLogout/fetchAuthLogout";
import {fetchAuthLogin} from "./services/fetchAuthLogin/fetchAuthLogin";
import {fetchRequestPasswordReset} from "./services/fetchRequestPasswordReset/fetchRequestPasswordReset";
import {fetchResetPassword} from "./services/fetchResetPassword/fetchResetPassword";


const initialState: IAuthProfile = {
    isMainLoading: true,
    isAuthentication: false,
    isGuestSessionReady: false,
    isNavbarLoading: false,
    isShowModalAuth: false
}

export const authSlice = createSlice({
    name: 'authSlice',
    initialState,
    reducers: {
        setIsAuthentication(state, action: PayloadAction<boolean>) {
            state.isAuthentication = action.payload
        },
        setIsGuestSessionReady(state, action: PayloadAction<boolean>) {
            state.isGuestSessionReady = action.payload
        },
        changeIsMainLoading(state, action: PayloadAction<boolean>) {
            state.isMainLoading = action.payload
        },
        changeIsNavbarLoading(state, action: PayloadAction<boolean>) {
            state.isNavbarLoading = action.payload
        },
        clearErrors(state) {
            state.error = undefined
            state.errorRegister = undefined
        },
        setIsShowModalAuth(state, action: PayloadAction<boolean>) {
            state.isShowModalAuth = action.payload
        },
        clearForgotPasswordState(state) {
            state.forgotPassword = undefined
        },
        clearResetPasswordState(state) {
            state.resetPassword = undefined
        },
        clearRegistrationSuccess(state) {
            state.isRegistrationSuccess = undefined
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAuthRegister.pending, (state) => {
                state.isNavbarLoading = true
                state.error = undefined
                state.errorRegister = undefined
            })
            .addCase(fetchAuthRegister.fulfilled, (state) => {
                state.isNavbarLoading = false
                state.isRegistrationSuccess = true
            })
            .addCase(fetchAuthRegister.rejected, (state, action) => {
                if (typeof action.payload === "object") {
                    state.errorRegister = action.payload
                } else {
                    // @ts-ignore
                    state.error = action.payload?.message
                }
                state.isNavbarLoading = false
            })

            .addCase(fetchAuthLogout.fulfilled, (state, action: PayloadAction<boolean>) => {
                state.isNavbarLoading = false
                state.isAuthentication = action.payload
            })

            .addCase(fetchAuthLogin.pending, (state) => {
                state.isNavbarLoading = true
                state.error = undefined
            })
            .addCase(fetchAuthLogin.fulfilled, (state) => {
                state.isNavbarLoading = false
            })
            .addCase(fetchAuthLogin.rejected, (state, action) => {
                state.error = action.payload
                state.isNavbarLoading = false
            })

            .addCase(fetchRequestPasswordReset.pending, (state) => {
                state.forgotPassword = {
                    isLoading: true,
                    isSuccess: false,
                    error: undefined,
                    emailError: undefined
                }
            })
            .addCase(fetchRequestPasswordReset.fulfilled, (state) => {
                state.forgotPassword = {
                    isLoading: false,
                    isSuccess: true,
                }
            })
            .addCase(fetchRequestPasswordReset.rejected, (state, action) => {
                state.forgotPassword = {
                    isLoading: false,
                    isSuccess: false,
                    error: action.payload?.error,
                    emailError: action.payload?.emailError,
                }
            })

            .addCase(fetchResetPassword.pending, (state) => {
                state.resetPassword = {
                    isLoading: true,
                    isSuccess: false,
                    error: undefined,
                }
            })
            .addCase(fetchResetPassword.fulfilled, (state) => {
                state.resetPassword = {
                    isLoading: false,
                    isSuccess: true,
                }
            })
            .addCase(fetchResetPassword.rejected, (state, action) => {
                state.resetPassword = {
                    isLoading: false,
                    isSuccess: false,
                    error: action.payload?.error,
                }
            })

    },
})


export const authReducer = authSlice.reducer
export const authAction = authSlice.actions


